// eslint-disable-next-line no-restricted-imports
import { Container, ContainerProps, Image } from "@carrotfertility/carotene" // please do not import from @carrotfertility/carotene after eslint rule added on 3/20/25
import React from "react"
import underwaterSeaweed from "../resources/images/underwater-seaweed.png"
import underwaterSeaweed2x from "../resources/images/underwater-seaweed-2x.png"
import underwaterPlants from "../resources/images/underwater-plants.png"
import underwaterPlants2x from "../resources/images/underwater-plants-2x.png"
import underwaterPlantsRight from "../resources/images/underwater-plants-right.png"
import underwaterPlantsRight2x from "../resources/images/underwater-plants-right-2x.png"
import personRight from "../resources/images/person_right.png"

export const UnderwaterSeaweed = (props: ContainerProps): JSX.Element => {
  return (
    <Container {...props}>
      <Image
        src={underwaterSeaweed}
        srcSet={underwaterSeaweed2x}
        altText=""
        width={"128px"}
        height={"72px"}
        sx={{
          transform: "scaleX(-1)"
        }}
      />
    </Container>
  )
}
export const UnderwaterPlants = (props: ContainerProps): JSX.Element => {
  return (
    <Container {...props}>
      <Image
        src={underwaterPlants}
        srcSet={underwaterPlants2x}
        altText=""
        width={"156px"}
        height={"96px"}
        sx={{
          transform: "scaleX(-1)"
        }}
      />
    </Container>
  )
}
export const UnderwaterPlantsRight = (props: ContainerProps): JSX.Element => {
  return (
    <Container {...props}>
      <Image
        src={underwaterPlantsRight}
        srcSet={underwaterPlantsRight2x}
        altText=""
        width={"188px"}
        height={"96px"}
        sx={{
          transform: "scaleX(-1)"
        }}
      />
    </Container>
  )
}

export const Person = (props: ContainerProps): JSX.Element => {
  return (
    <Container {...props}>
      <Image
        src={personRight}
        altText=""
        width={"225px"}
        height={"480px"}
        sx={{
          "[dir='rtl'] &": {
            transform: "scaleX(-1)"
          }
        }}
      />
    </Container>
  )
}
